import React, { useState } from "react";
import PatientOrders from "components/common/food/patientOrders";
//import Orders from "components/common/food/orders";
import { Menu } from "semantic-ui-react";
//import Catalog from "./catalog";

type FoodProps = {
  patientId?: string;
  org?: string;
};

const Food: React.FC<FoodProps> = ({ patientId, org }) => {
  const [activeItem, setActiveItem] = useState('Orders');

  const handleMenuItemClick = (e, { name }) => {
    setActiveItem(name);
  };

  return patientId
    ? <PatientOrders patientId={patientId} />
    : <div>
      <Menu pointing>
        {/* <Menu.Item
          key="catalog"
          name="Catalog"
          active={activeItem === 'Catalog'}
          onClick={handleMenuItemClick}
        /> */}
        <Menu.Item
          key="orders"
          name="Orders"
          active={activeItem === 'Orders'}
          onClick={handleMenuItemClick}
        />
        {/* <Menu.Item
          key="draftOrders"
          name="DraftOrders"
          active={activeItem === 'DraftOrders'}
          onClick={handleMenuItemClick}
        />
        <Menu.Item
          key="deliveries"
          name="Deliveries"
          active={activeItem === 'Deliveries'}
          onClick={handleMenuItemClick}
        /> */}
      </Menu>
      {/* {activeItem === 'Catalog' &&
        <Catalog
          //patient={props.patient}
          vendor={'EW'} // TODO: change from hardcoded to dynamic?
          handleMenuItemClick={handleMenuItemClick}
          //patientId={patientId}
          //profileData={props.profileData}
          org={org}
        //allReferralData={props.allReferralData}
        //ordersMutate={ordersMutate}
        />
      } */}
      {activeItem === 'Orders' &&
        <PatientOrders
          patientId={null}
        />
      }
      {/* {activeItem === 'DraftOrders' &&
        <PatientOrders
          patientId={null}
          organizationId={org}
          status={"draft"}
        />
      }
      {activeItem === 'Deliveries' &&
        <PatientOrders
          patientId={null}
          organizationId={org}
          status={"DELIVERED,DELIVERY UNCONFIRMED,DELIVERY_UNCONFIRMED"}
        />
      } */}
    </div>
};

export default Food;
